import React from 'react'
import { storiesOf } from '@storybook/react'

import { withState } from 'recompose'
import TextInput from 'components/TextInput'

storiesOf('TextInput', module)
  .add('default', () => {
    const TextInputContainer = withState('value', 'onChange', '')(TextInput)
    return <TextInputContainer />
  })
